/* eslint-disable */

import Vue from "vue";
import router from "../../routes";

const FbAuth = "https://identitytoolkit.googleapis.com/v1/accounts:";
const FbApiKey = "AIzaSyDNNQbG2KsN2bhFl-yjPHwlprGWsPgiWnQ";

const admin = {
	namespaced: true,
	state: {
		token: null,
		refresh: null,
		authFailed: false,
		refreshLoading: true,
		addpost: false,
		editPost: null,
		addtag: false,
		addcategory: false,
		imageUpload: null,
		adminPosts: null,
		tags: null,
		categories: null,
		category: null,
		tag: null,
		totalPostCount: 0,
		totalPostViews: 0,
		averageRating: 0,
	},
	getters: {
		isAuth(state) {
			if (state.token) {
				return true;
			}
			return false;
		},
		refreshLoading(state) {
			return state.refreshLoading;
		},
		addPostStatus(state) {
			return state.addpost;
		},
		editPostStatus(state) {
			return state.editpostStatus;
		},
		addTagStatus(state) {
			return state.addtag;
		},
		addCategoryStatus(state) {
			return state.addcategory;
		},
		imageUpload(state) {
			return state.imageUpload;
		},
		getAdminPosts(state) {
			return state.adminPosts;
		},
		getTags(state) {
			return state.tags;
		},
		getCategories(state) {
			return state.categories;
		},
		getTotalPostCount(state) {
			return state.totalPostCount;
		},
		getTotalPostViews(state) {
			return state.totalPostViews;
		},
		getAveragePostRating(state) {
			return state.averageRating;
		},
		getSingleCategory(state) {
			return state.category;
		},
		getSingleTag(state) {
			return state.tag;
		},
		editPost(state) {
			return state.editPost;
		}
	},
	mutations: {
		authUser(state, authData) {
			state.token = authData.idToken;
			state.refresh = authData.refreshToken;

			if (authData.type === "signin") {
				router.push("/dashboard");
			}
		},
		authFailed(state, type) {
			if (type === "reset") {
				state.authFailed = false;
			} else {
				state.authFailed = true;
			}
		},
		logoutUser(state) {
			state.token = null;
			state.refresh = null;

			localStorage.removeItem("token");
			localStorage.removeItem("refresh");

			router.push("/");
		},
		refreshLoading(state) {
			state.refreshLoading = false;
		},
		addPost(state) {
			state.addpost = true;
		},
		addTag(state) {
			state.addtag = true;
		},
		addCategory(state) {
			state.addcategory = true;
		},
		clearAddPost(state) {
			state.addpost = false;
		},
		clearAddTag(state) {
			state.addtag = false;
		},
		clearAddCategory(state) {
			state.addcategory = false;
		},
		imageUplod(state, imageData) {
			state.imageUpload = imageData;
		},
		clearImageUpload(state) {
			state.imageUpload = null;
		},
		getAdminPosts(state, posts) {
			state.adminPosts = posts;
		},
		getTags(state, tags) {
			state.tags = tags;
		},
		getCategories(state, categories) {
			state.categories = categories;
		},
		getTotalPostCount(state, count) {
			state.totalPostCount = count;
		},
		getTotalPostViews(state, count) {
			state.totalPostViews = count;
		},
		getAveragePostRating(state, count) {
			state.averageRating = count;
		},
		getSingleCategory(state, category) {
			state.category = category;
		},
		getSingleTag(state, tag) {
			state.tag = tag;
		},
		editPost(state, editPost) {
			state.editPost = editPost;
		},
	},
	actions: {
		signIn({ commit }, payload) {
			Vue.http
				.post(`${FbAuth}signInWithPassword?key=${FbApiKey}`, {
					...payload,
					returnSecureToken: true
				})
				.then(response => response.json())
				.then(authData => {
					commit("authUser", {
						...authData,
						type: "signin"
					});
					localStorage.setItem("token", authData.idToken);
					localStorage.setItem("refresh", authData.refreshToken);
				})
				.catch(error => {
					commit("authFailed");
				});
		},
		refreshToken({ commit }) {
			const refreshToken = localStorage.getItem("refresh");
			if (refreshToken) {
				Vue.http
					.post(`https://securetoken.googleapis.com/v1/token?key=${FbApiKey}`, {
						grant_type: "refresh_token",
						refresh_token: refreshToken
					})
					.then(response => response.json())
					.then(authData => {
						commit("authUser", {
							idToken: authData.id_token,
							refreshToken: authData.refresh_token,
							type: "refresh"
						});
						commit("refreshLoading");
						localStorage.setItem("token", authData.id_token);
						localStorage.setItem("refresh", authData.refresh_token);
					});
			} else {
				commit("refreshLoading");
			}
		},
		addPost({ commit, state }, payload) {
			Vue.http
				.post(`posts.json?auth=${state.token}`, payload)
				.then(response => response.json())
				.then(response => {
					commit("addPost");
					setTimeout(() => {
						commit("clearAddPost");
					}, 3000);
				});
		},
		updatePost({ commit, state }, payload) {
			Vue.http
				.patch(`posts/${payload.id}.json?auth=${state.token}`, payload.data)
				.then(response => response.json())
				.then(response => {
					let item = state.adminPosts.find(element => element.id === payload.id);
					item.id = payload.id;
					item.title = response.title;
					item.desc = response.desc;
					item.rating = response.rating;
				});
		},
		addTag({ commit, state }, payload) {
			Vue.http
				.post(`tags.json?auth=${state.token}`, payload)
				.then(response => response.json())
				.then(response => {
					commit("addTag");
					setTimeout(() => {
						commit("clearAddTag");
					}, 3000);
				});
		},
		addCategory({ commit, state }, payload) {
			Vue.http
				.post(`categories.json?auth=${state.token}`, payload)
				.then(response => response.json())
				.then(response => {
					commit("addCategory");
					setTimeout(() => {
						commit("clearAddCategory");
					}, 3000);
				});
		},
		updateCategory({ commit, state }, payload) {
			Vue.http
				.patch(`categories/${payload.id}.json?auth=${state.token}`, payload.data)
				.then(response => response.json())
				.then(response => {
					let item = state.categories.find(element => element.id === payload.id);
					item.id = payload.id;
					item.name = response.name;
					item.slug = response.slug;
				});
		},
		updateTag({ commit, state }, payload) {
			Vue.http
				.patch(`tags/${payload.id}.json?auth=${state.token}`, payload.data)
				.then(response => response.json())
				.then(response => {
					let item = state.tags.find(element => element.id === payload.id);
					item.id = payload.id;
					item.name = response.name;
					item.slug = response.slug;
				});
		},
		imageUpload({ commit }, file) {
			const CLOUDINARY_URL =
				"https://api.cloudinary.com/v1_1/dgbufyqzt/image/upload";
			const CLOUDINARY_PRESET = "q4pbygy6";
			let formData = new FormData();
			formData.append("file", file);
			formData.append("upload_preset", CLOUDINARY_PRESET);

			Vue.http
				.post(CLOUDINARY_URL, formData, {
					headers: {
						"Content-type": "application/x-www-form-urlencoded"
					}
				})
				.then(response => response.json())
				.then(response => {
					commit("imageUplod", response.secure_url);
				});
		},
		getAdminPost({ commit }) {
			Vue.http
				.get("posts.json")
				.then(response => response.json())
				.then(response => {
					const posts = [];
					for (let key in response) {
						posts.push({
							...response[key],
							id: key
						});
					}
					commit("getAdminPosts", posts.reverse());
				});
		},
		getTag({ commit }) {
			Vue.http
				.get("tags.json")
				.then(response => response.json())
				.then(response => {
					const tags = [];
					for (let key in response) {
						tags.push({
							...response[key],
							id: key
						});
					}
					commit("getTags", tags.reverse());
				});
		},
		getCategory({ commit }) {
			Vue.http
				.get("categories.json")
				.then(response => response.json())
				.then(response => {
					const categories = [];
					for (let key in response) {
						categories.push({
							...response[key],
							id: key
						});
					}
					commit("getCategories", categories.reverse());
				});
		},
		deletePost({ commit, state }, payload) {
			Vue.http
				.delete(`posts/${payload}.json?auth=${state.token}`)
				.then(response => {
					let newPost = [];
					state.adminPosts.forEach(post => {
						if (post.id != payload) {
							newPost.push(post);
						}
					});
					commit("getAdminPosts", newPost);
				});
		},
		deleteTag({ commit, state }, payload) {
			Vue.http
				.delete(`tags/${payload}.json?auth=${state.token}`)
				.then(response => {
					let newTag = [];
					state.tags.forEach(tag => {
						if (tag.id != payload) {
							newTag.push(tag);
						}
					});
					commit("getTags", newTag);
				});
		},
		deleteCategory({ commit, state }, payload) {
			Vue.http
				.delete(`categories/${payload}.json?auth=${state.token}`)
				.then(response => {
					let newCategory = [];
					state.categories.forEach(category => {
						if (category.id != payload) {
							newCategory.push(category);
						}
					});
					commit("getCategories", newCategory);
				});
		},
		getPostCount({ commit }) {
			Vue.http
				.get("posts.json")
				.then(response => {
					let avrageRating = 0;
					let postView = 0;
					var count = Object.keys(response.body).length;
					if (count) {
						let sum = 0;
						for (let key in response.body) {
							sum += parseInt(response.body[key].rating);
							postView += parseInt(response.body[key].views);
						}
						avrageRating = sum / count;
					}
					commit("getTotalPostViews", postView);
					commit("getTotalPostCount", count);
					commit("getAveragePostRating", avrageRating.toFixed(2));
				});
		},
		getSingleCategory({ commit }, payload) {
			Vue.http.get(`categories.json?orderBy="$key"&startAt="${payload}"&limitToFirst=1`)
				.then(response => response.json())
				.then(response => {
					const categories = [];
					for (let key in response) {
						categories.push({
							...response[key],
						});
					}
					commit("getSingleCategory", categories[0]);
				});
		},
		getSingleTag({ commit }, payload) {
			Vue.http.get(`tags.json?orderBy="$key"&startAt="${payload}"&limitToFirst=1`)
				.then(response => response.json())
				.then(response => {
					const tags = [];
					for (let key in response) {
						tags.push({
							...response[key],
						});
					}
					commit("getSingleTag", tags[0]);
				});
		},
		editPost({ commit }, payload) {
			Vue.http.get(`posts.json?orderBy="$key"&startAt="${payload}"&limitToFirst=1`)
				.then(response => {
					commit("editPost", response.body[payload]);
					commit("imageUplod", response.body[payload].img);
				});
		},
		postViews({ commit, state }, payload) {
			Vue.http.get(`posts.json?orderBy="slug"&startAt="${payload}"&limitToFirst=1`)
				.then(response => response.json())
				.then(response => {
					for (let key in response) {
						let count = (response[key].views) ? response[key].views : 0;
						Vue.http.patch(`posts/${key}.json`, { views: count + 1 })
							.then(response => response.json())
							.then(response => {
								console.log(response);
							});
					}
				})
		},
	}
};

export default admin;
